import { render, staticRenderFns } from "./prize-product-dialog.vue?vue&type=template&id=2f8bd8a1&scoped=true&"
import script from "./prize-product-dialog.vue?vue&type=script&lang=js&"
export * from "./prize-product-dialog.vue?vue&type=script&lang=js&"
import style0 from "./prize-product-dialog.vue?vue&type=style&index=0&id=2f8bd8a1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8bd8a1",
  null
  
)

export default component.exports